<ng-container *ngLet="(breakPointObserve$ | async) as screenRes">
  @if (!screenRes.matches) {
    <button
      class="btn-empty btn-with-icon"
      (click)="onClick($event)"
      [matTooltip]="fileName"
    >
      @if (showIcon()) {
        <svg [icon]="icons.Doc" class="svg24 dark-gray-color" />
      }
      <span class="link-3 file-name">{{ fileName }}</span>
    </button>
  } @else {
    <div
      class="link-3 file-name mobile"
      (click)="onClick($event)"
    >
      @if (showIcon()) {
        <svg [icon]="icons.Doc" class="svg24 dark-gray-color" />
      }
      <div>{{ fileName }}</div>
    </div>
  }
</ng-container>
